var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarchartdcactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17L0 17L8.74228e-08 18L24 18L24 17Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18L2 18L2 9L7 9L7 18ZM2.88825 17.1684L6.09741 17.1684L6.09741 9.83159L2.88825 9.83159L2.88825 17.1684Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18L9 18L9 5L14 5L14 18ZM9.88839 17.1759L13.1118 17.1759L13.1118 5.83743L9.88839 5.83743L9.88839 17.1759Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18L16 18L16 0L21 -4.37114e-07L21 18ZM16.8882 17.1653L20.1118 17.1653L20.1118 0.834698L16.8882 0.834698L16.8882 17.1653Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarchartdcactive);
export default __webpack_public_path__ + "static/media/bar chart dọc active.95a8db9df4d98e701ebd70bd534c5209.svg";
export { ForwardRef as ReactComponent };